import React, { useState, useEffect, useCallback, useRef } from 'react';
import N3rveLogo from './../../../images/nerveblacklogo.png'
import './PaymentPage.css'
import { BrowserRouter as Router, Route, Routes, Link, useLocation, useNavigate, Navigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next'
import i18next from "i18next"
import axios from 'axios'
import { loadStripe } from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
import CircularProgress from '@mui/material/CircularProgress';

import { logtoWix } from '../../Helpers/LogToWix';

import Cookies from 'universal-cookie';

const stripePromise = loadStripe("pk_test_51OUA4oK7blWsA75sa2Pd7zTWiapNFi0wPYycjK2y4MGoxLw2WFTmVcgG4pwpMfN26e1uvDt8QAbY1MFv4Wz0IaPT00ltD4BQsL");

const cookies = new Cookies(null, { path: '/' });

const params = new URLSearchParams(document.location.search);


const CheckoutForm = () => {

  const fetchClientSecret = useCallback(() => {

    return fetch('https://n3rve.fly.dev/auth/plan', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer ".concat(cookies.get("token"))
      },
      body: JSON.stringify({
        plan: cookies.get("plan"),
        // domain:"https://n3rve-b4b3b625d069.herokuapp.com"
        domain: "http://localhost:3000"
      })
    })
      .then((res) => res.json())
      .then((data) => data.clientSecret);
  }, []);

  const options = { fetchClientSecret };
  console.log(options)

  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={options}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>

    </div>
  )
}

const Return = () => {
  const [status, setStatus] = useState(null);
  const [customerEmail, setCustomerEmail] = useState('');
  const location = useLocation();

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get('session_id');

    fetch(`/session-status?session_id=${sessionId}`)
      .then((res) => res.json())
      .then((data) => {
        setStatus(data.status);
        setCustomerEmail(data.customer_email);
      });
  }, []);

  if (status === 'open') {
    return (
      <section id="failure">
        <p>
          Error with payment.
        </p>
      </section>
    )
  }

  if (status === 'complete') {
    return (
      <Navigate to="/AccountDetails" state={{ email: location.state.email }} />
    )
  }

  return null;
}


function PaymentPage() {
  const [planSelect, setPlanSelect] = useState(2);
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const hasLogged = useRef(false);


  const cookies = new Cookies(null, { path: '/' });
  const email = cookies.get("email")

  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  })



  useEffect(() => {
    console.log("Sesssion Id")
    console.log(params.get("session_id"))
    console.log(email)
    console.log(cookies.get("plan"))
    if (params.get("session_id") !== null) {
      CheckStatus()
    }

    if (!hasLogged.current) {
      logtoWix(email, "pageview", "Stripe Page", { "desc": "User opened the Stripe Page", "plan": cookies.get("plan") })
    }

  }, [])

  const CheckStatus = () => {
    axios({
      method: 'get',
      url: "https://n3rve.fly.dev/payment/success?session_id=".concat(params.get("session_id")),
      headers: {
        Authorization: "Bearer ".concat(cookies.get("token"))
      }
    }).then((response) => {
      if (response.status === 200) {
        console.log(response)

        logtoWix(email, "Stripe success", "Stripe Page", { "desc": "User successfully paid for plan", "plan": cookies.get("plan") })

        cookies.set('token', response.data.token)
        navigate("/AccountDetails", { state: { email: email } })
      }
    }).catch(function (e) {
      console.log(e.response)
    })
  }

  return (
    <div style={{ width: '100%', height: '100vh', backgroundColor: '#f9fafa' }}>

      {/* <Routes>
          <Route path="/checkout" element={<CheckoutForm />} />
          <Route path="/return" element={<Return />} />
        </Routes> */}
      {
        params.get("session_id") === null &&
        <div style={{ paddingBottom: '5em', backgroundColor: '#f9fafa' }}>
          <img src={N3rveLogo} style={{ width: '5.58em', height: '2.5em', marginTop: '1.75em', marginLeft: '23.5%' }} />
          <CheckoutForm />
        </div>
      }

      {
        params.get("session_id") !== null &&
        <div style={{ backgroundColor: 'rgba(0,0,0,20%)', height: '100%', width: '100%' }}>
          <CircularProgress style={{ position: 'fixed', margin: 'auto', marginTop: '20%', marginLeft: '45%', width: '5em', height: '5em' }} sx={{ color: '#FFFFFF' }} />
        </div>
      }


    </div>
  );
}

export default PaymentPage;